import * as React from 'react';
import IconButton from '@mui/material/IconButton';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import PropTypes from 'prop-types';
import CircularProgress from '@mui/material/CircularProgress';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import TaskQueueCard from './TaskQueueCard';
import { keyframes, ListSubheader, Stack } from '@mui/material';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { styled } from '@mui/material/styles';
import * as Api from '../../../../api/task';
import { useEffect, useRef } from 'react';
import { useRequest, useClickAway } from 'ahooks';
import { useDispatch, useSelector } from 'react-redux';
import {POLLING_TASKS, SELECT_A_TASK} from 'store/actions';
import { number2precision } from 'utils/numberFormat';
import useToast from 'hooks/useToast';
import { useNavigate } from 'react-router-dom';
import Button from '@mui/material/Button';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { Trans, useTranslation } from 'react-i18next';
import defaultLanguage from 'i18n/defaultLanguage';

const progressStatus = {
  loading: {
    color: 'secondary',
    variant: 'indeterminate'
  },
  normal: {
    color: 'success',
    variant: 'determinate'
  }
};
function CircularProgressWithLabel({ loading, value }) {
  return (
    <Box sx={{ position: 'relative', display: 'inline-flex' }}>
      <CircularProgress {...progressStatus[value >= 100 && !loading ? 'normal' : 'loading']} value={value} />
      <Box
        sx={{
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center'
        }}
      >
        <Typography variant="caption" component="div">
          {`${value || 0}%`}
        </Typography>
      </Box>
    </Box>
  );
}

CircularProgressWithLabel.propTypes = {
  value: PropTypes.number.isRequired
};

const queueData = [
  {
    taskId: '0002',
    task: 'txt2img',
    state: '执行中',
    isvip: true
  }
];

const rotateStyle = keyframes`
  0% {
    background-position: 0% 50%
  }
  50% {
    background-position: 100% 50%
  }
  100% {
    background-position: 0% 50%
  }
`;

const GaListSubheader = styled(ListSubheader)(({ theme }) => ({
  background: 'linear-gradient(-45deg, #990066, #FFCC00, #CC0033)',
  backgroundSize: '500% 500%',
  animation: `${rotateStyle} 15s infinite`
}));

const ITEM_HEIGHT = 68;

export default () => {
  const { i18n } = useTranslation();
  const [taskListOpen, setTaskListOpen] = React.useState(!1);
  const [taskSelected, setTaskSelected] = React.useState();
  const [taskCount, setTaskCount] = React.useState(0);
  const [queueData, setQueueData] = React.useState({
    need_polling: !1,
    info: [],
    progress: 0
  });
  const [userSubscribe, setuserSubscribe] = React.useState(false);
  const toast = useToast();
  const navigate = useNavigate();

  const polling = useSelector((state) => state.polling);
  const dispatch = useDispatch();
  const anchorElRef = useRef();

  const getQueueTask = async () => {
    const { code, info } = await Api.queueTask().catch((e) => e);
    if (code === 0) {
      const { need_polling, tasks } = info || {};
      const count = tasks?.length;
      let progress = 100;
      if (count) {
        const done = tasks.filter((i) => i.state === 'done');
        // todo set current Count
        const taskCounts = tasks.filter((i) => i.state === 'pending').length;
        setTaskCount(taskCounts);
        // todo scale base pending as: currentDone/pending
        progress = number2precision((done.length / count) * 100, 0);

        // 任务结果等待中
        if (polling) {
          const { task_id } = polling;
          const task = done.find((i) => i.task_id === task_id);
          if (task) {
            dispatch({ type: SELECT_A_TASK, task });
          }
        }
      }
      setQueueData({ need_polling, tasks, progress });
      if (need_polling === false) {
        cancel();
        // todo 若等待中的任务未返回，且轮询状态终止，则取消等待???允许服务端误差存在，大概是个*任务，下一个
      }
    } else {
      cancel();
      // todo toast
    }
  };

  const resolvePollingQueue = () => {
    // 当前没有轮询
    if (!loading && !setQueueData.neet_polling) {
      // 进度归0
      queueData.progress = 0;
      setQueueData(queueData);
      // 轮询
      setTimeout(() => {
        run();
      }, 50);
    } else {
      // polling 中 pass
    }
  };

  // The polling logic is to wait for pollingInterval time after each request is completed, and then initiate the next request.
  const { data, loading, run, cancel } = useRequest(getQueueTask, {
    // Polling interval, in milliseconds. If the value is greater than 0, the polling mode is activated.
    pollingInterval: 0.1,
    pollingWhenHidden: false,
    pollingErrorRetryCount: 3,
    manual: !0
  });

  useClickAway(() => {
    setTaskListOpen(!1);
  }, anchorElRef);

  useEffect(() => {
    resolvePollingQueue();
  }, []);

  useEffect(() => {
    // 任务轮询约定，收到有效task指令，则开启轮询，否则不予响应
    if (polling) resolvePollingQueue();
  }, [polling]);

  const handleSelectTask = (event, task) => {
    // todo selected/unselected
    // setTaskSelected(task);
    if (task.state !== 'done') {
      toast('玩命处理中，请稍后～', { variant: 'warning' });
      return;
    }
    // { state: task }
    if (location.pathname !== '/paint') navigate('/paint');

    dispatch({ type: SELECT_A_TASK, task });
  };

  return (
    <>
      <IconButton>
        <CircularProgressWithLabel loading={loading} value={queueData.progress} />
      </IconButton>
      <Button
        ref={anchorElRef}
        aria-label="more"
        id="long-button"
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        onClick={(e) => {
          setTaskListOpen(!0);
        }}
      >
        <Typography
          sx={{
            color: '#4D4D4D',
            fontSize: 13
          }}
        >
          {taskCount ? (
            i18n.t('toolbar.taskCount', { taskCount })
          ) : (
            <Trans i18nKey="toolbar.no_running">{defaultLanguage.toolbar.no_running}</Trans>
          )}
        </Typography>
        <KeyboardArrowDownIcon sx={{ color: '#4D4D4D' }}></KeyboardArrowDownIcon>
      </Button>
      <Menu
        variant="selectedMenu"
        id="long-menu"
        MenuListProps={{
          'aria-labelledby': 'long-button'
        }}
        anchorEl={anchorElRef?.current}
        open={taskListOpen}
        onClose={setTaskListOpen}
        PaperProps={{
          style: {
            maxHeight: ITEM_HEIGHT * 4.5,
            width: '45ch'
          }
        }}
      >
        {userSubscribe ? (
          <></>
        ) : (
          <GaListSubheader
            sx={{
              height: 50
            }}
          >
            <ListItem
              sx={{
                width: '100%',
                height: 50
              }}
            >
              <ListItemText
                sx={{ textAlign: 'center' }}
                primary={<Trans i18nKey="toolbar.task_list_purchase">{defaultLanguage.toolbar.task_list_purchase}</Trans>}
              />
            </ListItem>
          </GaListSubheader>
        )}

        {queueData?.tasks?.map((item) => (
          // todo replace menuItem to list
          <MenuItem
            key={item.taskId}
            onClick={(e) => {
              handleSelectTask(e, item);
            }}
          >
            <TaskQueueCard selected={!1} form={item} />
          </MenuItem>
        ))}
      </Menu>
    </>
  );
};
